import { useWeb3React } from '@web3-react/core';
// import moment from 'moment';
// import { useContext } from 'react';
import useSWR from 'swr';
// import appContext from '../../../context/app/appContext';
import {
    Address,
    IncentivizeRewardsDto,
    SpoolDto,
    UserIncentivizedRewardsDto,
} from '../../..//types/spool-local';
import { sleep } from '../../../web3/utils';
import { AVAILABLE_SPOOLS } from './data';

// const INCENTIVIZED_REWARDS_FAKE_TOKENS = ['0xece2b4cb29cf6ee46f52cbdcc17890f60b6bbf07'];

type AvailableSpool = SpoolDto & {
    incentivizedRewards: IncentivizeRewardsDto[];
    userData:
        | {
              userIncentivizedRewards: UserIncentivizedRewardsDto[];
              id: string;
              user: Address;
              pendingDepositAmount: number;
              pendingWithdrawalAmount: number;
              userClaimableAmount: number;
              userYieldEarnedToDateAmount: number;
              userCurrentBalance: number;
              userShares: string;
          }
        | undefined;
};

const useAvailableSpools = () => {
    const { account, chainId } = useWeb3React();

    // const { sdk } = useContext(appContext);

    const { data, error } = useSWR(
        // sdk ? ['availableSpools', account, chainId] : null,
        ['availableSpools', account, chainId],
        async (_, userAddress): Promise<AvailableSpool[]> => {
            await sleep(1000);

            return AVAILABLE_SPOOLS;
            // if (!userAddress) {
            //     const allSpools = await sdk!.spools.getAllSpools();
            //     return allSpools.map((spool) => ({
            //         ...spool,
            //         incentivizedRewards: spool.incentivizedRewards.filter(
            //             (incentivizedReward) =>
            //                 moment
            //                     .unix(+incentivizedReward.emissionEndDate)
            //                     .isAfter(moment()) &&
            //                 !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
            //                     incentivizedReward.id.toLowerCase()
            //                 )
            //         ),
            //         userData: spool.userData
            //             ? {
            //                   ...spool.userData,
            //                   userIncentivizedRewards:
            //                       spool.userData?.userIncentivizedRewards.filter(
            //                           (incentivizedReward) =>
            //                               !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
            //                                   incentivizedReward.token.id.toLowerCase()
            //                               )
            //                       ),
            //               }
            //             : undefined,
            //     }));
            // }

            // const spoolIDs = await sdk!.spools.getAllSpoolIdsWithUserParticipation(
            //     userAddress
            // );

            // const spools = await Promise.all(
            //     Object.entries(spoolIDs).map(
            //         async ([spoolAddress, isUserParticipated]) => {
            //             const spool = await (isUserParticipated
            //                 ? sdk!.spools.getUserSpool(userAddress, spoolAddress)
            //                 : sdk!.spools.getSpoolById(spoolAddress));
            //             return spool!;
            //         }
            //     )
            // );

            // return spools.map((spool) => ({
            //     ...spool,
            //     incentivizedRewards: spool.incentivizedRewards.filter(
            //         (incentivizedReward) =>
            //             moment
            //                 .unix(+incentivizedReward.emissionEndDate)
            //                 .isAfter(moment()) &&
            //             !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
            //                 incentivizedReward.id.toLowerCase()
            //             )
            //     ),
            //     userData: spool.userData
            //         ? {
            //               ...spool.userData,
            //               userIncentivizedRewards:
            //                   spool.userData?.userIncentivizedRewards.filter(
            //                       (incentivizedReward) =>
            //                           !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
            //                               incentivizedReward.token.id.toLowerCase()
            //                           )
            //                   ),
            //           }
            //         : undefined,
            // }));
        }
    );

    return {
        availableSpools: data,
        isLoading: !error && !data,
        error,
    };
};

export default useAvailableSpools;
